import React, {
  useRef,
  useEffect,
  useState,
  useContext,
} from "react";

import MapView from "@arcgis/core/views/MapView";
import esriConfig from "@arcgis/core/config";
import IconWidget from "./widgets/IconWidget.js";
import IconWidgetMulti from "./widgets/IconWidgetMulti.js";
import LayerList from "@arcgis/core/widgets/LayerList";
import DateWidgetHeatMap from "./widgets/DateWidgetHeatMap.js";
import SearchToGraphic from "./widgets/AddSearchToGraphicBtn.js";
import Basemap from "@arcgis/core/Basemap";
import DataWidget from "./widgets/DataWidget.js";
import VectorTileLayer from "@arcgis/core/layers/VectorTileLayer";
import WebMap from "@arcgis/core/WebMap";
import Graphic from "@arcgis/core/Graphic";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Polyline from "@arcgis/core/geometry/Polyline.js";
import Multipoint from "@arcgis/core/geometry/Multipoint.js";
import * as locator from "@arcgis/core/rest/locator.js";
import * as colorRendererCreator from "@arcgis/core/smartMapping/renderers/color.js";

import ButtonApp from "./ButtonApp";
import { MapContext } from "./MapContext";
import * as renderInfo from "./PopUpRenderer/renderPopUp";
import contextToLayer from "./helpers/contextToLayer";
import Sidebar from "./widgets/Sidebar.js";
import CompareSidebar from "./widgets/CompareSidebar.js";
//import Grid from "./__mocks__/@arcgis/core/widgets/Grid";
import Grid from "./widgets/Grid.js";
import TimePicker from "./widgets/TimePicker.js";
import DataInfo from "./widgets/DataInfoCard.js";
import VTMap from "./widgets/VTMap.js";

// Grafika searcho testavimui
import SimpleMarkerSymbol from "@arcgis/core/symbols/SimpleMarkerSymbol";

import {
  extent,
  dayLayer,
  nightLayer,
  hexGrid,
  operator,
  juduLayer,
  VTReach,
} from "./Services/serviceLayers";
import {
  schoolPre,
  schoolElementary,
  schoolHigher,
  schoolBasic,
  hospital,
  dentist,
  publicOffice,
  busStops,
  busRoutes,
  blackSpots,
  parking,
  parkingBike,
  wazeHistory,
  walkingRoads,
} from "./Services/serviceAdditionalData";

import { cimBusSymbol, cimBusSymbolZoomOut } from "./PopUpRenderer/renderAdditionalDataLayers.js";
import "./App.css";
import "./Judumas.css";
import Header from "./Header";
import ClearButton from "./widgets/ClearButton.js";
import urlsImport from "./Services/services.js";
import HideSidebar from "./widgets/HideSideBar.js";
import Legend from "./widgets/Legend.js";
import {
  queryFeaturesOverLimit,
  queryFeaturesOverLimit2k,
} from "./helpers/helper";
import Search from "@arcgis/core/widgets/Search";
import InfoCard from "./widgets/InfoCard.js";
import Error from "./widgets/Error.js";
import ContextLayers from "./widgets/ContextLayers.js";
import LegendSISP from "./widgets/LegendSISP.js";
import { zoomRules, targetCarZoomAgg } from "./helpers/zoomRules.js";

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

function Appv2({ keycloak }) {
  const mapContext = useContext(MapContext);
  //const mapFeatureLayer = mapContext.state.featureLayer;
  //const mapFeatureUrl = mapContext.state.url;

  // MapValue naudojamas uzduociai parinkti (heatmap, pasiekiamumas ...) galbut butu prasminga pakeisti i kita pavadinima
  const [MapValue, setMapValue] = useState(0);

  // initialRenderer naudojamas patikrinti ar sukurtas zemelapis settinamas tik viena karta po zemelapio sukurimo ir reikiamu elementu priskirimo
  const [initialRender, setInitialRender] = useState(0);
  // liko is pries man paimant projekta su pradiniu zemelapio kurimu reiktu issiaiskinti ar naudingas ir galbut istrinti ?
  const [mapState, setMapState] = useState(new WebMap());
  // itraukiamas pirminis layeris kuris naudojamas kit teste
  const [fetchedLayers, setFetchedLayers] = useState([]);
  // paimamas  Oauth tokenas is url naudojamas
  const [token, setToken] = useState(null);
  // tikriausiai nenaudojamas reiktu istrinti ir paziuret ar neatsiranda bugu
  const [authorization, setAuthorization] = useState(false);
  // flag'as grazinimui i pirmine busena 
  const [refreshFlag, setRefreshFlag] = useState(false);
  // zoom'o flagas pakeisti zoom taisykles prie tam tikru lygiu
  const [zoomVisualFlag, setZoomVisualFlag] = useState(-1);
  // search komponentui, jis laikinai isjungtas nes dingo servisas , kai servisas bus atkurtas reikes ijungti
  // TODO: Re-enable search widget when ArcGIS Search widget is fixed
  // const [search, setSearch] = useState(new Search());
  const [search, setSearch] = useState(null);

  // hitTest atsakymas reiktu pakeisti pavadinima is bendrinio i specifiskesni
  const [response, setResponse] = useState(null);
  const [searchObj, setSearchObj] = useState(null);
  // hit test'o duomenys sudeti i obejkta gatviu atalitikai ir palyginimui naudoti
  const [layerData, setLayerData] = useState([
    "Paspauskite ant linijos",
    { month: "nėra duomenų", date: "nėra duomenų", sum_total: "nėra duomenų" },
  ]);

  // sisp'o duomenu flagas ir datos saugojimas
  const [juduFlag, setJuduFlag] = useState(false);
  const [SISPDate, setSISPDate] = useState([]);
  // SERVICE knows which service is in use, this is used to query DATA

  //Services are maps that are taken from arcgisOnline page of Vilniaus Planas
  //featureServices are Maps ready to be uploaded to UI


  let mapDiv = useRef(null);
  let interceptorAdded = useRef(false);

  // Set up APISIX proxy and interceptor once on component mount
  useEffect(() => {
    if (keycloak && !interceptorAdded.current) {
      interceptorAdded.current = true;
      const APISIX_PROXY = process.env.REACT_APP_APISIX_PROXY || "https://api.idvilnius.lt";
      const ENDPOINT = process.env.REACT_APP_APISIX_ENDPOINT || "judumas";
      console.log(APISIX_PROXY, ENDPOINT)

      // Add proxy rule to route opencity requests through APISIX
      const urlUtils = require("@arcgis/core/core/urlUtils");
      urlUtils.addProxyRule({
        urlPrefix: "https://opencity.idvilnius.lt",
        proxyUrl: `${APISIX_PROXY}/${ENDPOINT}/`,
      });

      // Add interceptor for Keycloak Bearer token
      esriConfig.request.interceptors.push({
        urls: "https://opencity.idvilnius.lt",
        before: async function (params) {
          params.requestOptions.headers = {
            ...params.requestOptions.headers,
            "Authorization": `Bearer ${keycloak.token}`
          };
        },
      });
    }
  }, [keycloak]);

  useEffect(() => {
    if (mapDiv.current && keycloak && interceptorAdded.current) {
      // Set up map and layers - only after interceptor is added
      let shouldRender = initialRender;

      async function TokenGenerate() {


        // paimimamas pradinio lango layeris ir pridedamas i fetchedLayerius, veliau panaudojamas hit test'o metu, klausimas ar jo reikia kaip useState komponento, padarytas zymiai seniau reiktu pasiaiskinti
        let fetchedLayersLocal = fetchedLayers;

        if (!fetchedLayersLocal.includes(mapContext.state.featureLayer.id)) {
          setFetchedLayers([
            ...fetchedLayers,
            mapContext.state.featureLayer.id,
          ]);
        }
        let layer = mapContext.state.featureLayer;

        // adding map to UI
        if (shouldRender === 1) {
          let updateMap = mapState;
          updateMap.add(layer);
          setMapState(updateMap);
        } else {
          const vector = new VectorTileLayer({
            portalItem: {
              id: "310451258aa04b2095c3526917cfb372",
            },
          });
          
          const basemap = new Basemap({
            baseLayers: [vector],
          });
          const map = new WebMap({
            basemap: basemap,
          });
          //console.log(map)
          setMapState(map);

          const view = new MapView({
            container: mapDiv.current,
            map: map,
            center: [25.2797, 54.6872],
            zoom: 14,
            ui: {
              components: []
            }
          });

          mapContext.dispatch({
            mapView: view,
          });

          // konetkstiniai duomenys
          let dataContext = [
            schoolPre,
            schoolBasic,
            schoolElementary,
            schoolHigher,
            hospital,
            dentist,
            publicOffice,
            busStops,
            busRoutes,
            blackSpots,
            parking,
            parkingBike,
            wazeHistory,
            walkingRoads
          ];

          // sudedami layeriai i zemelapi
          let layerGraphics = new GraphicsLayer();
          map.add(layerGraphics);
          map.add(layer);
          map.add(extent);

          // add context layers
          map.add(schoolPre);
          map.add(schoolBasic);
          map.add(schoolElementary);
          map.add(schoolHigher);

          map.add(hospital);
          map.add(dentist);
          map.add(publicOffice);

          map.add(hexGrid);
          map.add(blackSpots);
          map.add(parking);
          map.add(parkingBike);

          map.add(busRoutes);
          map.add(busStops);
          map.add(juduLayer);

          map.add(wazeHistory);
          map.add(walkingRoads);

          
          //console.log(walkingRoads)

          juduFiltering();
          let reachContext = [hexGrid, dayLayer, nightLayer];

          // kontekstiniai duomenys sudedami i bendra mapContext
          mapContext.dispatch({
            dataContextLayers: [...dataContext],
          });
          // pasiekiamumo layeriai sudedami i mapContext
          mapContext.dispatch({
            reachLayers: [...reachContext],
          });

          // paquerinamas extentas - miesto ribu polyline ir pridedamas i konteksta
          let extentGeoQuery = extent.createQuery();
          extentGeoQuery.where = "1=1";

          try{
            const result = await extent.queryFeatures(extentGeoQuery);

              mapContext.dispatch({
                extentGeometry: result.features[0].geometry,
              });

          } catch (error) {
            console.error('queryFeatures failed, layer:' , extent , ' query:' , extentGeoQuery , ' error:', error);
          }

          // hittestas gauti paspausta gatve, idedama i response useState
          view.on("click", async function (event) {
           
            const layer = fetchedLayers.forEach((element) => {
              if (element.visible) return element;
              else return null;
            });
            var opts = {
              include: layer,
            };
            var data = await view.hitTest(event, opts);
            //console.log(data.results)
            data.results = data.results.filter((result) => {
              try {
                const matchingContextFeature = dataContext.find(
                  (layer) => (layer.url === result.layer.url) && (result.layer.url !== busStops.url)
                );
                //console.log(matchingContextFeature)
                return !matchingContextFeature;
              } catch (error) {
                console.error("Failed to filter hit test result", error);
                return true;
              }
            });
            //console.log(data.results)
            //console.log("Hit test results:", data.results);
            data.searchFlag = false;
            setResponse(data);

          });
          //console.log("VOIE")
          // Add UI widgets after view is ready
          view.when(() => {
            try {
              // Add back safe UI components (avoiding the problematic Zoom widget)
              // Add attribution
              view.ui.add("attribution", "bottom-left");

              // layerlistas, isjungti kai deployinama i prod
              const layerlist = new LayerList({
                view: view,
              });

              // comment line bellow for PROD build
              //view.ui.add(layerlist, "bottom-right");

              // Initialize search widget safely after view is ready
              try {
                // Use the direct opencity URL - it will be intercepted by our APISIX proxy rule
                const searchServiceUrl = "https://opencity.idvilnius.lt/server/rest/services/Lokatoriai/Gatviu_lokatorius_JUDUMUI/GeocodeServer";

                //console.log("Initializing search widget with URL:", searchServiceUrl);

                const searchWidget = new Search({
                  view: view,
                  includeDefaultSources: false,
                  popupEnabled: false,
                  sources: [
                    {
                      url: searchServiceUrl,
                      singleLineFieldName: "Name",
                      outFields: ["*"],
                      name: "ID Vilnius Locator",
                      // Custom getResults to fetch ALL results instead of just top 1
                      getResults: async (params) => {
                        try {
                          const searchTerm = params.suggestResult
                            ? params.suggestResult.text
                            : params.searchTerm;

                         //console.log("Getting results for:", searchTerm);

                          // Use findAddressCandidates endpoint directly to get ALL results
                          const findAddressCandidatesUrl = `${searchServiceUrl}/findAddressCandidates`;

                          // Use esriRequest instead of fetch so it goes through our interceptor
                          const esriRequest = require("@arcgis/core/request").default;
                          const response = await esriRequest(findAddressCandidatesUrl, {
                            query: {
                              Name: searchTerm,
                              f: "json",
                            },
                            responseType: "json",
                          });

                          const data = response.data;
                         //console.log("Results from findAddressCandidates:", data);

                          const candidates = data.candidates || [];
                         //console.log("Total candidates:", candidates.length);

                          // Return ALL results with proper structure
                          return candidates.map((result, idx) => ({
                            name: result.address || `Result ${idx + 1}`,
                            location: result.location,
                            feature: {
                              geometry: result.location,
                              attributes: result.attributes || {},
                            },
                          }));
                        } catch (error) {
                          console.error("Search error details:", error);
                          console.error("Error message:", error?.message);
                          console.error("Error response:", error?.response);
                          return [];
                        }
                      },
                    },
                  ],
                });

                searchWidget.on("search-complete", (result) => {
                  //console.log("Search complete result:", result);
                  setSearchObj(result);
                });

                setSearch(searchWidget);
                view.ui.add(searchWidget, { position: "top-right" });


                //console.log("Search widget added successfully");
              } catch (searchError) {
                console.warn("Search widget initialization failed:", searchError);
              }
            } catch (error) {
              console.error("Error adding UI widgets:", error);
            }
          });

          setZoomVisualFlag(0);
        }
        // legendai sukuriami queriai gauti max reiksmes 
        let propertyDynamicRangesLegend = "usage";
        //GET max value of feature layer
        if (mapContext.state.data === "analytics" || MapValue !== 0) {
          mapContext.dispatch({
            maxValue: 0,
          });
          setZoomVisualFlag(4);
          return;
        } else if (mapContext.state.data.toLowerCase() === "sisp") {
          return;
        } else if (mapContext.state.data.toLowerCase() === "operator") {
          //Add dynamic renderer once i have data in op rates hour
          var queryOptions = {
            onStatisticField: "usage",
            outStatisticFieldName: "max_value",
            statisticType: "max",
          };
        } else {
          propertyDynamicRangesLegend = "sum_total";
          var queryOptions = {
            onStatisticField: "sum_total",
            outStatisticFieldName: "max_value",
            statisticType: "max",
          };
        }

        // Metiniuose sluoksniuose yra kelerių metų duomenys (pvz. 2023, 2024, 2025).
        // Legendai, spalvoms ir max reikšmei reikia tik naujausių metų. Filtrą paduodame
        // TIESIOGIAI (sqlWhere / query.where), o NE per sluoksnio definitionExpression –
        // kitaip createClassBreaksRenderer skaito sluoksnį jo atsinaujinimo metu ir grąžina
        // "insufficient-data". Geometrijos filtrą (LayerView.filter) pritaikome PABAIGOJE.
        // Kiekvieni metai įrašyti viena tikslia data – visi tų metų bruožai turi tą pačią datą.
        let yearWhere = null;
        if (mapContext.state.time && mapContext.state.time.toLowerCase() === "year") {
          try {
            const dateQuery = mapContext.state.featureLayer.createQuery();
            dateQuery.where = "1=1";
            dateQuery.outStatistics = [
              { statisticType: "max", onStatisticField: "date", outStatisticFieldName: "maxDate" },
            ];
            const dateResult = await mapContext.state.featureLayer.queryFeatures(dateQuery);
            const maxDate = dateResult.features[0] && dateResult.features[0].attributes.maxDate;
            if (maxDate != null) {
              const iso = new Date(maxDate).toISOString(); // pvz. 2025-12-31T23:00:00.000Z
              yearWhere = "date = timestamp '" + iso.slice(0, 10) + " " + iso.slice(11, 19) + "'";
            }
          } catch (error) {
            console.error('Year filter (max date) query failed:', error);
          }
        }

        //legenda suskirstoma pagal natural-breaks reiksmes, breakai idedami i konteksta
        let query = mapContext.state.featureLayer.createQuery();
        query.outStatistics = [queryOptions];
        if (yearWhere) {
          query.where = yearWhere;
        }

         {
          let rendererParams = {
            layer: mapContext.state.featureLayer,
            field: propertyDynamicRangesLegend,
            classificationMethod: "natural-breaks",
            numClasses: 100,
          };
          // Filtruojame statistikos užklausą tiesiogiai, nepriklausomai nuo sluoksnio būsenos.
          if (yearWhere) {
            rendererParams.sqlWhere = yearWhere;
          }
          /*console.log(
            "rendererParams",
            rendererParams,
            mapContext.state.featureLayer
          );
          */

          colorRendererCreator
            .createClassBreaksRenderer(rendererParams)
            .then((rendererResponse) => {
              //console.log("Breaks:", rendererResponse.renderer.classBreakInfos);
              mapContext.dispatch({
                breaks: rendererResponse.renderer.classBreakInfos,
              });
            })
            .catch((error) => {
              console.error('Color renderer creation failed:', error);
              mapContext.dispatch({
                breaks: [],
              });
            });

          try{
            const result = await mapContext.state.featureLayer.queryFeatures(query);

              let stats = result.features[0].attributes;

              mapContext.dispatch({
                maxValue: stats.max_value,
              });
              setZoomVisualFlag(4);
            
          } catch (error) {
            console.error('queryFeatures failed, layer:' , mapContext.state.featureLayer , ' query:' , query , ' error:', error);
          }

          // Geometrijos filtras žemėlapyje – naudojame LayerView.filter, o NE sluoksnio
          // definitionExpression (pastarasis sugadina createClassBreaksRenderer). LayerView.filter
          // keičia tik tai, kas MATOMA, neliesdamas sluoksnio užklausų.
          const viewForFilter = mapContext.state.mapView;
          const layerForFilter = mapContext.state.featureLayer;
          if (viewForFilter && typeof viewForFilter.whenLayerView === "function" && layerForFilter) {
            viewForFilter
              .whenLayerView(layerForFilter)
              .then((layerView) => {
                layerView.filter = yearWhere ? { where: yearWhere } : null;
              })
              .catch(() => {});
          }

        }
      }

      TokenGenerate();

      if (shouldRender === 1) {
        return;
      }
    }

    setInitialRender(1);
  }, [MapValue, mapContext.state.featureLayer, authorization, juduFlag]);

  


  useEffect(() => {
    // paslepiami/rodomi layeriai kurie aktualus pasiekiamumo pradiniam langui
    if (initialRender === 1) {
      if (mapContext.state.transportation !== "Car") {
        mapContext.state.featureLayer.visible = false;
      }
      if (MapValue === 3) {
        mapContext.state.dataContextLayers.forEach((layer, index) => {
          if (index != mapContext.state.dataContextLayers.length)
            if (layer.url === busStops.url || layer.url === busRoutes.url) {
              layer.visible = false;
            } else {
              layer.visible = false;
            }

        });

        mapContext.state.reachLayers[0].visible = true;
      } else {
        //console.log(mapContext.state.mapView.map);
        mapContext.state.mapView.map.layers.forEach((layer) => {
          if (layer.title === "Empty Hex Grid" || layer.title === "Correlation Grid" || layer.title === "HexGraphic") {
            try {
              layer.visible = false;
            } catch (error) {
              console.error(`Error hiding layer ${layer.title}:`, error);
            }
          }
        })
        
        mapContext.state.dataContextLayers.forEach((layer) => {
          layer.visible = false;
        });
        mapContext.state.reachLayers[0].visible = false;
      }
    }

    // Hide/show esri-widget based on MapValue
    const mapDiv = document.querySelector('.mapDiv');
    if (mapDiv) {
      if (MapValue === 2 || MapValue === 3) {
        mapDiv.classList.add('hide-esri-widgets');
      } else {
        mapDiv.classList.remove('hide-esri-widgets');
      }
    }
  }, [MapValue]);

  // isvalomas search'as pakeiciant uzduoti, kadangi GA uzduotyje searchas turi netik parodyti gatve bet ir ja palikt paryskinta, bei parodyti analaitika
  useEffect(() => {
    if (initialRender === 0) {
      return;
    }
    if (search) {
      search.clear();
    }
    if (MapValue !== 1) {
      mapContext.dispatch({
        searchToGraphic: false,
      });
    }
    if (MapValue === 1 ){
      document.getElementsByClassName("esri-search")[0].style.width = "40px"
      document.getElementsByClassName("esri-search__input-container")[0].style.display = "none"  
      document.getElementsByClassName("esri-search")[0].onclick = () => {
          mapContext.dispatch({
            searchFlag: 1,
          });        
      }  
    }
    return;

  }, [MapValue]);

  //Papildomas hittest resultatu isvalymas jei uzduotis nera VT pasiekiamumas stotelems isimti 


  useEffect(() => {
    if (initialRender === 1)
    {
   //console.log("Feature layer changed",  mapContext.state.featureLayer)
    }
  }, [mapContext.state.featureLayer]);

  // paslepiamas judu layeris
  useEffect(() => {
    if (initialRender === 1) {
      if (MapValue !== 0) {
        juduLayer.visible = false;
      }
    }
  }, [MapValue]);

  // Monitor and remove Correlation Grid layer if MapValue !== 3
  useEffect(() => {
    if (initialRender === 0 || !mapContext.state.mapView || !mapContext.state.mapView.map || MapValue === 3) {
      return;
    }

    const correlationGridLayer = mapContext.state.mapView.map.layers.find(
      (layer) => layer.title === "Correlation Grid"
    );

    if (correlationGridLayer) {
      try {
        mapContext.state.mapView.map.remove(correlationGridLayer);
       //console.log("Removed unwanted Correlation Grid layer (MapValue !== 3)");
      } catch (error) {
        console.error("Error removing Correlation Grid layer:", error);
      }
    }
  }, [mapContext.state.layerCreationLoading]);



  useEffect(() => {
   //console.log("Layer creation loading state changed:", mapContext.state.layerCreationLoading);
  }, [mapContext.state.layerCreationLoading]);


  // priskiriamos renderinimo taisykles pagal break'us ir maxValue, heatmap uzduotyje
  useEffect(() => {
    if (mapContext.state.data === "analytics" && MapValue !== 0) {
      return;
    }

    try {
      if (mapContext.state.data.toLowerCase() === "operator") {
        if (
          mapContext.state.transportation.toLowerCase() === "bike" ||
          mapContext.state.transportation.toLowerCase() === "pedestrian" ||
          mapContext.state.transportation.toLowerCase() === "bus"
        ) {
          mapContext.state.featureLayer.renderer =
            renderInfo.trailsRendererOperatorNonCarDynamic(
              mapContext.state.breaks
            );
        }
      } else if (mapContext.state.data.toLowerCase() === "strava") {
        mapContext.state.featureLayer.renderer =
          renderInfo.trailsRendererStravaNonCarDynamic(mapContext.state.breaks);
      }
    } catch (error) {
      console.error("Failed to apply feature layer renderer", error);
    }
  }, [mapContext.state.breaks]);

  // senas priskirimas kai break'ai nebuvo skaicuojami, o renderis buvo paskiriamas pagal maxValue reiksme ja suskistant intervalais, tikriausiai nebenaudojamas reik perziuret ir pratrinti.
  useEffect(() => {
    if (mapContext.state.data === "analytics" && MapValue !== 0) {
      return;
    }
    if (mapContext.state.data.toLowerCase() === "operator") {
      mapContext.state.featureLayer.renderer =
        renderInfo.trailsRendererOperatorDynamic(mapContext.state.maxValue);

    } 
    if (
      MapValue === 0 &&
      mapContext.state.maxValue !== null &&
      mapContext.state.maxValue !== undefined
    ) {
      mapContext.state.featureLayer.visible = true;
    }
  }, [mapContext.state.maxValue]);



  // didelis if clause'as paskirstyti featureLayeriui priklausomai nuo transportacijos, datos, duomenu tipo ir uzduoties, reiktu perdaryt i paprastesni.
  useEffect(() => {
    if (
      mapContext.state.time !== null &&
      mapContext.state.transportation !== null &&
      mapContext.state.data !== null
    ) {
      let contextToLayer_param = {
        data: null,
        time: null,
        transportation: null,
      };
     //console.log("contextToLayer_param", mapContext.state.transportation, mapContext.state.time, mapContext.state.data);
      if (mapContext.state.data.toLowerCase() === "analytics") {
        contextToLayer_param.data = 2;
        contextToLayer_param.time = 0;
        contextToLayer_param.transportation = 0;
      } else {
        if (mapContext.state.data.toLowerCase() === "strava") {
          contextToLayer_param.data = 0;
        }
        if (mapContext.state.data.toLowerCase() === "operator") {
          contextToLayer_param.data = 1;
        }
        if (mapContext.state.data.toLowerCase() === "sisp") {
          contextToLayer_param.data = 1;
        }

        if (mapContext.state.transportation.toLowerCase() === "bike") {
          contextToLayer_param.transportation = 0;
        }
        if (mapContext.state.transportation.toLowerCase() === "pedestrian") {
          contextToLayer_param.transportation = 1;
        }
        if (mapContext.state.transportation.toLowerCase() === "car") {
          contextToLayer_param.transportation = 2;
        }
        if (mapContext.state.transportation.toLowerCase() === "bus") {
          contextToLayer_param.transportation = 3;
        }
        if (mapContext.state.transportation.toLowerCase() === "sum") {
          contextToLayer_param.transportation = 4;
        }

        if (mapContext.state.time.toLowerCase() === "day") {
          contextToLayer_param.time = 0;
        }
        if (mapContext.state.time.toLowerCase() === "week") {
          contextToLayer_param.time = 1;
        }
        if (mapContext.state.time.toLowerCase() === "month") {
          contextToLayer_param.time = 2;
        }
        if (mapContext.state.time.toLowerCase() === "year") {
          contextToLayer_param.time = 3;
        }
        if (mapContext.state.time.toLowerCase() === "hour") {
          contextToLayer_param.time = 4;
        }
      }

      if (MapValue === 0) {
        setZoomVisualFlag(0);
      }
      if (MapValue !== 0) {
        contextToLayer_param.data = 2;
      }

      
     //console.log("contextToLayer_param", contextToLayer_param);
      let obj_2 = contextToLayer.contextToLayer_02(
        contextToLayer_param.data,
        contextToLayer_param.transportation,
        contextToLayer_param.time
      );

      //console.log("obj_2", obj_2);

      if (obj_2.featureLayer === undefined || obj_2.url === undefined) {
        /*console.log(
          "contextToLayer.contextToLayer_02 returned undefined, check parameters"
        );
        */
        return;
      }

      if (contextToLayer_param.data == 2) {
        //console.log("contextToLayer_param.data == 2");
        if (mapContext.state.transportation.toLowerCase() === "car") {
          mapContext.dispatch({
            dataFeatureLayer: contextToLayer.contextToLayer_02(2, 2, 1)
              .featureLayer,
          });
          mapContext.dispatch({
            dataurl: contextToLayer.contextToLayer_02(2, 2, 1).url,
          });
        } else if (mapContext.state.transportation.toLowerCase() === "bike") {
          mapContext.dispatch({
            dataFeatureLayer: contextToLayer.contextToLayer_02(2, 0, 1)
              .featureLayer,
          });
          mapContext.dispatch({
            dataurl: contextToLayer.contextToLayer_02(2, 0, 1).url,
          });
        } else if (
          mapContext.state.transportation.toLowerCase() === "pedestrian"
        ) {
          mapContext.dispatch({
            dataFeatureLayer: contextToLayer.contextToLayer_02(2, 1, 1)
              .featureLayer,
          });
          mapContext.dispatch({
            dataurl: contextToLayer.contextToLayer_02(2, 1, 1).url,
          });
        } else if (mapContext.state.transportation.toLowerCase() === "bus") {
          mapContext.dispatch({
            dataFeatureLayer: contextToLayer.contextToLayer_02(2, 3, 1)
              .featureLayer,
          });
          mapContext.dispatch({
            dataurl: contextToLayer.contextToLayer_02(2, 3, 1).url,
          });
        }
      }

      if (mapContext.state.data.toLowerCase() === "sisp") {
        setJuduFlag(!juduFlag);
      }

     //console.log("obj_2", obj_2);
      mapContext.dispatch({
        featureLayer: obj_2.featureLayer,
      });
      mapContext.dispatch({
        url: obj_2.url,
      });
      //console.log(mapContext.state.featureLayer);
      /* VN sum 
      if (mapContext.state.transportation.toLowerCase() === "sum") {
        mapContext.dispatch({
          featureLayer: op_sum_day,
        });
        mapContext.dispatch({
          url: op_sum_day.url,
        });
      }
      */

      mapContext.state.featureLayer.clone();

    }
  }, [
    mapContext.state.time,
    mapContext.state.transportation,
    mapContext.state.data,
    MapValue
  ]);

  // SISP'o duomenyse surandama didziausia data , legendos informacijos nurodymui
  function juduFiltering() {
    // Suziuret context to param ir legendos value ieskojimo
    juduLayer
      .queryFeatures({
        outFields: ["year", "month"],
        returnDistinctValues: true,
        where: "1=1", // Query all features
      })
      .then((result) => {
        const features = result.features;

        // Step 2: Extract unique years and months
        const years = [...new Set(features.map((f) => f.attributes.year))];
        //const months = [...new Set(features.map((f) => f.attributes.month))];

        // Step 3: Find the highest year and month
        const highestYear = Math.max(...years);
        const highestMonth = Math.max(
          ...features
            .filter((f) => f.attributes.year === highestYear)
            .map((f) => f.attributes.month)
        );


        // Step 4: Apply a filter to the layer
        const query = `year = ${highestYear} AND month = ${highestMonth}`;

        setSISPDate([highestYear, highestMonth]);
        juduLayer.definitionExpression = query; // Only show features with highest year and month

      })
      .catch((error) => {
        console.error('queryFeatures failed, layer:' , juduLayer , ' error:', error);
      });
  }

  // nubraizomas extent'o grafinis elementas
  useEffect(() => {

    if (
      mapContext.state.mapView.graphics === null &&
      mapContext.state.extentGeometry !== null
    ) {
      let symbol = {
        type: "simple-line", // autocasts as new SimpleLineSymbol()
        color: [232, 76, 49, 1],
        width: "4px",
        style: "solid",
      };
      var graphic = new Graphic(mapContext.state.extentGeometry, symbol);
      mapContext.state.mapView.graphics.add(graphic);
      return;
    }
    if (mapContext.state.extentGeometry !== null) {
      let symbol = {
        type: "simple-line", // autocasts as new SimpleLineSymbol()
        color: [232, 76, 49, 1],
        width: "4px",
        style: "solid",
      };

      var graphic = new Graphic(mapContext.state.extentGeometry, symbol);
      mapContext.state.mapView.graphics.add(graphic);
    }
  }, [mapContext.state.extentGeometry, mapContext.state.clearFlag, MapValue]);

  // isvalomi duomenys, grafikai, grafiniai elementai pakeitus uzduoti.
  useEffect(() => {

    if (initialRender === 0) {
      return;
    }

    //Isvalyti grido grafikas
    mapContext.state.mapView.map.layers.items.forEach((layer) => {
      if (layer.title === "HexGraphic" || layer.title === "Empty Hex Grid" || layer.title === "Correlation Grid") {
        try {
          if (typeof layer.removeAll === 'function') {
            layer.removeAll();
          }
          if (typeof layer.destroy === 'function') {
            layer.destroy();
          }
        } catch (error) {
          console.error(`Error destroying layer ${layer.title}:`, error);
        }
      }
    });

    mapContext.state.mapView.map.layers.items[0].graphics.removeAll()

    mapContext.dispatch({
      contextDataVisible: false,
    });
    mapContext.dispatch({
      layerLoading: 0,
    });
    mapContext.dispatch({
      calendarResetDates: 0,
    });
    if (MapValue !== 2) {
      mapContext.dispatch({
        compareTask: 0,
      });
    }

    if (MapValue === 1 || MapValue === 2) {
      mapContext.state.featureLayer.visible = false;
      mapContext.state.featureLayer.popupTemplate = null;

      mapContext.dispatch({
        data: "analytics",
      });
      mapContext.dispatch({
        time: "Day",
      });
      mapContext.dispatch({
        transportation: "Car",
      });

    } else {
      mapContext.state.featureLayer.visible = false;
      mapContext.state.featureLayer.popupTemplate = null;
      mapContext.dispatch({
        time: "Day",
      });
      mapContext.dispatch({
        transportation: "Car",
      });
      mapContext.dispatch({
        data: "operator",
      });
      mapContext.dispatch({
        selectedStreetArray: [],
      });
      mapContext.dispatch({
        dateRange: 0,
      });

      mapContext.state.mapView.graphics.removeAll();
      mapContext.dispatch({
        clearFlag: 1,
      });
      setLayerData([
        "Paspauskite ant linijos",
        {
          month: "nėra duomenų",
          date: "nėra duomenų",
          sum_total: "nėra duomenų",
        },
      ]);
    }
  }, [MapValue]);

  // isvalomi duomenys, grafikai, grafinia elementai kai aktyvuojamas clearFlag
  useEffect(() => {
    if (mapContext.state.clearFlag === 1) {

      mapContext.state.mapView.graphics.removeAll();
      setLayerData([
        "Paspauskite ant linijos",
        {
          month: "nėra duomenų",
          date: "nėra duomenų",
          sum_total: "nėra duomenų",
        },
      ]);
      mapContext.dispatch({
        clearFlag: 0,
      });
      mapContext.dispatch({
        selectedStreetArray: [],
      });
    }
  }, [mapContext.state.clearFlag]);

  useEffect(() => {
    if (initialRender === 0) {
      return;
    }
    if (MapValue === 4) {
      console.log("Setting minScale for VT layer to 36112 for MapValue 4");
      
      busStops.minScale = "36112";
      console.log(mapContext.state.dataContextLayers[7].minScale, mapContext.state.dataContextLayers[7].renderer);
      mapContext.state.dataContextLayers[7].renderer = {
        type: "simple",
        symbol: cimBusSymbolZoomOut,
      }
    } else {
      mapContext.state.dataContextLayers[7].renderer = {
        type: "simple",
        symbol: cimBusSymbol,
      }
    }
    mapContext.state.mapView.map.layers.forEach(layer => {
      if (layer.title === "VT pasiekiamumo duomenys") {
        try {
          if (typeof layer.removeAll === 'function') {
            layer.removeAll();
          }
          if (typeof layer.destroy === 'function') {
            layer.destroy();
          }
        } catch (error) {
          console.error(`Error destroying layer ${layer.title}:`, error);
        }
      }
    });
  }, [MapValue])

  // hittest'o rezultatu apdorojimas GA, palyginimui ir pasiekiamumui
  useEffect(() => {
    if (initialRender === 0) {
      return;
    }
    // rezultato pateikimas pasiekiamumui
    if (MapValue === 3) {

      let i;
      for (i = 0; i < response.results.length; i++) {
        if (response.results[i].layer !== null) {
          if (response.results[i].layer.url === hexGrid.url) {
            mapContext.dispatch({
              gridClickData: response.results[i],
            });
          }
        }
      }
    }
    if (
      MapValue !== 1 ||
      mapContext.state.sideBarRequestPending === 1 ||
      mapContext.state.dateRange === null ||
      response.results.length === 1
    ) {
      return;
    }
    /*

    Add support once Data is added to 
    op_rates_hour
    */
   // duoemnu apdorojimas GA ir palyginimui
    async function getData(searchFlag) {
      mapContext.dispatch({
        sideBarRequestPending: 1,
      });

      if (response !== null && response.results.length !== 0) {

        var data;

        var diagramData = {};
        var changeFlag = false;
        if (layerData[2] !== null && layerData[2] !== undefined) {
          diagramData = layerData[2];
        }
        if (layerData[3] !== null && layerData[3] !== undefined) {
          changeFlag = !layerData[3];
        }
        // New unquery graphic
        // paimamas paspaustos gatves OSM id ir querinami jos usage duomenys
        if (response.results[0].layer === null) {
          let queryWhere = "osm_id IN ('";
          response.results[0].graphic.attributes.selectedStreetIds.forEach(
            (element) => {
              queryWhere += element + "','";
            }
          );
          queryWhere = queryWhere.slice(0, -2);
          queryWhere += ") and " + mapContext.state.dateRange;

          var query = mapContext.state.dataFeatureLayer.createQuery();
          query.where = queryWhere;

          const features = await queryFeaturesOverLimit2k(
            mapContext.state.dataFeatureLayer,
            query,
            mapContext
          );
          if (features.length === 0) {
            mapContext.dispatch({
              clearFlag: 1,
            });
            mapContext.dispatch({
              sideBarRequestPending: 0,
            });
            return;
          }

          let proccesedCount = 0;
          features.forEach((element) => {
            proccesedCount++;
            // year: 'numeric', month: 'numeric', day: 'numeric',
            const options = { hour: "numeric" };
            // Atimti kelias atkarpas
            diagramData[
              new Date(element.attributes.datetime).toLocaleDateString(
                "en-US",
                { ...options, timeZone: "UTC" }
              )
            ] -= element.attributes.usage;
            if (proccesedCount == features.length) {
              mapContext.dispatch({
                sideBarRequestPending: 0,
              });
            }
          });

          data = [
            "Operatorių duomenys",
            { date: null, sum_total: null },
            diagramData,
            changeFlag,
          ];
          // usage duomenys priskiriami layerdatai
          setLayerData(data);
          return;
        }

        //
        //  paimamas paspaustos gatves OSM id ir querinami jos usage duomenys, atrenkami aktualus layeriai , buvo bugas kuomet susikirto su kontekstinias duomenim ir bandydavo is ju gauti duomenis, reik perziuret dar karta ar rpies tai naudojamas queris yra naudingas.
        if (response.results.length >= 2) {
          var id;
          let layerflag = true;
          let layerindex = 0;
          while (layerflag === true) {
            if (response.results[layerindex].layer !== null) {
              if (
                response.results[layerindex].layer.url ===
                  "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer" ||
                response.results[layerindex].layer.url ===
                  "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer"
              ) {
                id = response.results[layerindex].graphic.attributes.osm_id;
                layerflag = false;
              }
            }

            layerindex++;
            if (layerindex === response.results.length) {
              layerflag = false;
              data = [
                "Operatorių duomenys",
                { date: null, sum_total: null },
                diagramData,
              ];

              setLayerData(data);

              return;
            }
          }

          let filteredResponse = [...response.results];
          filteredResponse = filteredResponse.filter(
            (feature) => feature.layer !== null
          );

          if (searchFlag === false) {
            filteredResponse.pop();
          }
          let selectedIds = [];
          let str = "osm_id IN (";
          for (const singleId of filteredResponse) {
            selectedIds.push(singleId.graphic.attributes.osm_id);
            if (
              singleId.graphic.attributes.osm_id !== undefined &&
              singleId.graphic.attributes.osm_id !== null
            ) {
              str += singleId.graphic.attributes.osm_id + ",";
            }
          }
          let i = 0;
          if (selectedIds.includes(response.results[0].graphic.attributes.id)) {
            i = 1;
          }

          str = str.slice(0, -1);
          str += ") and " + mapContext.state.dateRange;
          var query = mapContext.state.dataFeatureLayer.createQuery();
          query.where = str;
          query.outFields = ["usage", "datetime"];
          query.cacheBust = true;

          const features = await queryFeaturesOverLimit2k(
            mapContext.state.dataFeatureLayer,
            query,
            mapContext
          );
          

          if (features.length === 0) {
            mapContext.dispatch({
              clearFlag: 1,
            });
            mapContext.dispatch({
              sideBarRequestPending: 0,
            });
            return;
          }
          query.where = "osm_id = " + id + "";

          layerflag = true;
          layerindex = 0;
          while (layerflag === true) {
            if (response.results[layerindex].layer !== null) {
              let proccesedCount = 0;
              if (
                selectedIds.includes(response.results[0].graphic.attributes.id)
              ) {
                features.forEach((element) => {
                  proccesedCount++;
                  // year: 'numeric', month: 'numeric', day: 'numeric',
                  const options = { hour: "numeric" };

                  diagramData[
                    new Date(element.attributes.datetime).toLocaleDateString(
                      "en-US",
                      { ...options, timeZone: "UTC" }
                    )
                  ] -= element.attributes.usage;
                  if (proccesedCount == features.length) {
                    mapContext.dispatch({
                      sideBarRequestPending: 0,
                    });
                  }
                });
              } else {
                features.forEach((element) => {
                  proccesedCount++;
                  // year: 'numeric', month: 'numeric', day: 'numeric',
                  const options = { hour: "numeric" };
                  if (
                    !diagramData.hasOwnProperty(
                      new Date(element.attributes.datetime).toLocaleDateString(
                        "en-US",
                        { ...options, timeZone: "UTC" }
                      )
                    )
                  ) {
                    diagramData[
                      new Date(element.attributes.datetime).toLocaleDateString(
                        "en-US",
                        { ...options, timeZone: "UTC" }
                      )
                    ] = 0;
                  }
                  // Prideti kelias atkarpas
                  diagramData[
                    new Date(element.attributes.datetime).toLocaleDateString(
                      "en-US",
                      { ...options, timeZone: "UTC" }
                    )
                  ] += element.attributes.usage;
                  if (proccesedCount == features.length) {
                    mapContext.dispatch({
                      sideBarRequestPending: 0,
                    });
                  }
                });
              }
              layerflag = false;
            }
            layerindex++;
            if (layerindex === response.results.length) {
              layerflag = false;
            }
          }
          data = [
            "Operatorių duomenys",
            { date: null, sum_total: null },
            diagramData,
            changeFlag,
          ];
        } else {
          data = [
            "Operatorių duomenys",
            { date: null, sum_total: null },
            diagramData,
          ];
        }

        setLayerData(data);
      }
    }

    getData(response.searchFlag);
    if (response === null) {
      return;
    }

    // grafiniai elementai priskiriami paspausdiem layeriam, arba nuimami jei layeris jau buvo paspaustas
    let symbol = {
      type: "simple-fill", // autocasts as new SimpleFillSymbol()
      color: [85, 255, 255, 6],
      style: "solid",
      outline: {
        // autocasts as new SimpleLineSymbol()
        color: [85, 255, 255, 6],
        width: 6,
      },
    };

    if (MapValue === 0) {
      return;
    }

    let layerflag = true;
    let layerindex = 0;
    // nuimami arba pridedami osm id i paspaustu layeriu array'u priklausomai nuo to ar jie buvo ar nebuvo paspausti
    while (layerflag === true) {
      if (response.results[layerindex].layer !== null) {
        let osmDuplicates = [];
        let removeDuplicates = [];
        for (let i = 0; response.results.length - 1 > i; i++) {
          if (
            response.results[i].graphic.attributes.osm_id !== undefined &&
            response.results[i].graphic.attributes.osm_id !== null &&
            !mapContext.state.selectedStreetArray.includes(
              response.results[i].graphic.attributes.osm_id
            )
          ) {
            osmDuplicates.push(response.results[i].graphic.attributes.osm_id);
          } else if (
            response.results[i].graphic.attributes.osm_id !== undefined &&
            response.results[i].graphic.attributes.osm_id !== null
          ) {
            removeDuplicates.push(
              response.results[i].graphic.attributes.osm_id
            );
          }
        }
        if (response.results[0].layer === null) {
          mapContext.state.mapView.graphics.remove(response.results[0].graphic);
          var arrayTemp = [...mapContext.state.selectedStreetArray];
          let filteredArray = arrayTemp.filter(
            (item) =>
              !response.results[0].graphic.attributes.selectedStreetIds.includes(
                item
              )
          );
          // Salint lauk visas gatves kurios vienoje atkarpoje
          mapContext.dispatch({
            selectedStreetArray: [...filteredArray],
          });
        } else {
          let filteredResponse = [...response.results];
          filteredResponse = filteredResponse.filter(
            (feature) => feature.layer !== null
          );
          filteredResponse.pop();
          let selectedIds = [];
          for (const singleId of filteredResponse) {
            selectedIds.push(singleId.graphic.attributes.osm_id);
          }

          var firstLayer = response.results[layerindex];
          var geometry = firstLayer.graphic.geometry;
          let attributes = {
            id: response.results[layerindex].graphic.attributes.osm_id,
            selectedStreetIds: [...selectedIds],
          };

          if (
            response.results[layerindex].graphic.attributes.osm_id !== undefined
          ) {
            // Pridet visas gatves kurios yra
            mapContext.dispatch({
              selectedStreetArray: [
                ...mapContext.state.selectedStreetArray,
                ...osmDuplicates,
              ],
            });
          }

          if (searchObj !== null) {
            const polylinePoints = searchObj.results[0].results.map((point) => [
              point.location.x,
              point.location.y,
            ]);

            polylinePoints.sort((a, b) => {
              if (a[0] === b[0]) {
                return a[1] - b[1];
              }
              return a[0] - b[0];
            });

            const polyline = new Polyline({
              paths: [polylinePoints],
              spatialReference: { wkid: 2600 }, // Assuming WGS84 coordinate system, adjust as needed
            });

            symbol.type = "simple-line";
            symbol.width = 6;
            var graphic = new Graphic(polyline, symbol, attributes);
            setSearchObj(null);
          } else {
            symbol.type = "simple-line";
            symbol.width = 6;
            var graphic = new Graphic(geometry, symbol, attributes);
            mapContext.state.mapView.graphics.add(graphic);
          }

        }
        layerflag = false;
      }
      layerindex++;
      if (layerindex === response.results.length) {
        layerflag = false;
      }
    }
  }, [response]);

  useEffect(() => {
    if (initialRender === 0) {
      return;
    } 
   //console.log("SearchObj useEffect", searchObj);
  },[searchObj]);
  // zoomui naudojamas useEffectas priklausomai nuo uzduodies ir zoom lygio pakeiciamos renderinimo taisykles
  useEffect(() => {
    if (zoomVisualFlag === -1) {
      return;
    }
    if (MapValue === 3) {
      
      for (
        let i = 0;
        i < mapContext.state.mapView.layerViews.items.length;
        i++
      ) {
        if (
          mapContext.state.mapView.layerViews.items[i].layer.visible === true
        ) {
          if (
            mapContext.state.mapView.layerViews.items[i].layer.visible === true
          ) {
            mapContext.state.mapView.layerViews.items[i].filter = null;
          }
        }
      }
      setZoomVisualFlag(-1);
      return;
    }

    if (
      MapValue === 0 &&
      mapContext.state.transportation.toLowerCase() === "car" &&
      mapContext.state.data.toLowerCase() == "operator"
    ) {
      // Funkcija pakeisti operatoriu masinas priklausomai nuo zoom lygio i sujungtas dideles gatves aarba atskiras dideles gatves
      let targetLayer = targetCarZoomAgg(mapContext);
      if (
        mapContext.state.featureLayer !== targetLayer &&
        mapContext.state.time.toLowerCase() !== "hour"
      ) {
        mapContext.state.featureLayer.visible = false;
        mapContext.dispatch({
          featureLayer: targetLayer,
        });
      } else {
        //console.log("Sutampa")
      }

    }
    let zoomState = zoomRules(mapContext, MapValue, zoomVisualFlag);
    setZoomVisualFlag(zoomState);
    return;
    
  }, [mapContext.state.mapView.zoom, refreshFlag, mapContext.state.transportation]);

  // pakeitus datai paquerinami nauji duomenys aktualus tai datai
  useEffect(() => {

    if (mapContext.state.selectedStreetArray.length == 0) {
      setLayerData([
        "Paspauskite ant linijos",
        {
          month: "nėra duomenų",
          date: "nėra duomenų",
          sum_total: "nėra duomenų",
        },
      ]);
      return;
    }

    if (MapValue === 0 || MapValue === 3 || MapValue === 2) {
      return;
    }
    getData();

    async function getData() {
      mapContext.dispatch({
        sideBarRequestPending: 1,
      });
      var data;
      var diagramData = {};
      for (const street of mapContext.state.selectedStreetArray) {
        var query = mapContext.state.dataFeatureLayer.createQuery();
        query.where =
          "osm_id =" + street + " and " + mapContext.state.dateRange;

        //console.log(mapContext.state.dataFeatureLayer, query)
        const queriedFeatures = await queryFeaturesOverLimit2k(
          mapContext.state.dataFeatureLayer,
          query,
          mapContext
        );
        if (queriedFeatures.length === 0) {
          mapContext.dispatch({
            clearFlag: 1,
          });
          mapContext.dispatch({
            sideBarRequestPending: 0,
          });
          //console.log("return")
          return;
        }

        queriedFeatures.forEach((element) => {
          const options = { hour: "numeric" };
          if (
            !diagramData.hasOwnProperty(
              new Date(element.attributes.datetime).toLocaleDateString(
                "en-US",
                { ...options, timeZone: "UTC" }
              )
            )
          ) {
            diagramData[
              new Date(element.attributes.datetime).toLocaleDateString(
                "en-US",
                { ...options, timeZone: "UTC" }
              )
            ] = 0;
          }
          diagramData[
            new Date(element.attributes.datetime).toLocaleDateString("en-US", {
              ...options,
              timeZone: "UTC",
            })
          ] += element.attributes.usage;
        });
      }

      data = [
        "Operatorių duomenys",
        {
          date: response.results[0].graphic.attributes.datetime,
          sum_total: response.results[0].graphic.attributes.usage,
        },
        diagramData,
      ];
     //console.log(data)
      setLayerData(data);
      mapContext.dispatch({
        sideBarRequestPending: 0,
      });
    }
  }, [mapContext.state.dateRange]);

  // layerio loadinimo elemento patikrinimas 
  useEffect(() => {
    setTimeout(() => {
      setRefreshFlag(!refreshFlag);
    }, 1000);
    if (initialRender === 0) {
      return;
    }
    mapContext.state.mapView.layerViews.items.forEach((layer) => {
      if (layer.visible === true && layer.layer.url !== null) {
        //console.log("Layer loading status:", layer.layer.title, layer.updating);
        if (layer.updating === true && mapContext.state.layerLoading === 0) {
          mapContext.dispatch({
            layerLoading: 1,
          });
        }
        if (layer.updating === false && mapContext.state.layerLoading === 1) {
          mapContext.dispatch({
            layerLoading: 0,
          });
        }
      }
    });
  }, [refreshFlag]);

  // search widgeto rezultatu apdorojimas idejimas i response state'a ir grafiniu elementu pridejimas
  useEffect(() => {

    if (
      initialRender === 0 ||
      searchObj === null ||
      searchObj.results[0].results.length === 0
    ) {
      return;
    }
   //console.log("searchObj structure:", searchObj);
   //console.log("First result:", searchObj?.results?.[0]);

    // Handle both SearchWidget results and SearchVM results
    let allResults = [];

    if (searchObj?.results && Array.isArray(searchObj.results) && searchObj.results[0]?.results) {
      // Old SearchWidget format
      allResults = searchObj.results[0].results;
    } else if (searchObj?.results && Array.isArray(searchObj.results)) {
      // SearchVM search result format - results is directly an array
      allResults = searchObj.results;
    }

   //console.log("Total results found:", allResults.length);

    const polylinePoints = allResults.map((point) => {
     //console.log("Processing point:", point);

      // Try different possible coordinate locations (handles both SearchWidget and SearchVM formats)
      if (point.feature?.geometry?.x !== undefined && point.feature?.geometry?.y !== undefined) {
        // Feature with geometry format (SearchVM result format)
        return [point.feature.geometry.x, point.feature.geometry.y];
      } else if (point.location && point.location.x !== undefined && point.location.y !== undefined) {
        // Standard format with location property
        return [point.location.x, point.location.y];
      } else if (point.geometry && point.geometry.x !== undefined && point.geometry.y !== undefined) {
        // Geometry property format
        return [point.geometry.x, point.geometry.y];
      } else if (point.x !== undefined && point.y !== undefined) {
        // Direct x, y properties
        return [point.x, point.y];
      }

      // If nothing found, log and skip
      console.warn("Could not extract coordinates from point:", point);
      return null;
    }).filter(p => p !== null);

   //console.log("Extracted points count:", polylinePoints.length);
   //console.log("First few points:", polylinePoints.slice(0, 5));

    const streetPart = searchObj.searchTerm.split(",")[0].trim();

    polylinePoints.sort((a, b) => {
      if (a[0] === b[0]) {
        return a[1] - b[1];
      }
      return a[0] - b[0];
    });

   //console.log("Polyline points:", polylinePoints[45]);
    const polyline = new Polyline({
      paths: [polylinePoints],
      spatialReference: { wkid: 2600 }, // Assuming WGS84 coordinate system, adjust as needed
    });

    const multipointGeometry = new Multipoint({
      points: polylinePoints,
      spatialReference: { wkid: 2600 }, // Assuming WGS84 coordinate system, adjust as needed
    });

    //Grafika testavimui search widgetui
    /*
    const pointSymbol = new SimpleMarkerSymbol({
      color: [255, 255, 0], // yellow
      size: 8,
      outline: {
        color: [255, 255, 255],
        width: 1
      }
    });

    const multipointGraphic = new Graphic({
      geometry: multipointGeometry,
      symbol: pointSymbol
    });

    
   //console.log(multipointGeometry)

    mapContext.state.mapView.graphics.add(multipointGraphic);
    */
    //Grafika baigiasi

    

    if (MapValue === 1 && mapContext.state.searchToGraphic === true) {
      mapContext.dispatch({
        searchFlag: 1,
      });
    }

    const CHUNK_SIZE = 30;
    let queryLayer = operator;

    delayWrapper();

    async function delayWrapper() {
      await delay(5000);
      mapContext.state.mapView.goTo({
        target: polyline,
      });
    }

    async function queryPointsInChunks() {
      try {
        let allResults = [];

        // Split points into chunks of 30
        for (let i = 0; i < polylinePoints.length; i += CHUNK_SIZE) {
          const chunk = polylinePoints.slice(i, i + CHUNK_SIZE);

          // Create multipoint geometry for this chunk
          const chunkMultipointGeometry = new Multipoint({
            points: chunk,
            spatialReference: { wkid: 2600 },
          });

          // Create query for this chunk
          let query = mapContext.state.featureLayer.createQuery();
          query.geometry = chunkMultipointGeometry;
          query.distance = 2;
          query.units = "meters";
          query.spatialRelationship = "intersects";
          query.returnGeometry = true;
          query.inputSpatialReference = { wkid: 2600 };
          query.outFields = ["*"];

         //console.log(`Querying chunk ${Math.floor(i / CHUNK_SIZE) + 1} with ${chunk.length} points`);

          // Execute query for this chunk
          const result = await queryLayer.queryFeatures(query);

          // Add results from this chunk to allResults
          result.features.forEach((feature) => {
            let singleObj = {
              graphic: feature,
              layer: feature.layer,
            };
            allResults.push(singleObj);
          });
        }

       //console.log(`Total features found: ${allResults.length}`);

        // Filter results by streetPart
        let objCollection = { results: [] };
        allResults.forEach((obj) => {
          const name = obj.graphic.attributes.name;
          if (name === streetPart || name === null) {
            objCollection.results.push(obj);
          }
        });

        objCollection.searchFlag = true;
        setResponse(objCollection);

        // Visualization
        let symbolConcPoly = {
          type: "simple-line",
          color: [85, 255, 255, 6],
          style: "solid",
          width: 6,
          outline: {
            color: [85, 255, 255, 6],
            width: 6,
          },
        };

        objCollection.results.forEach((result) => {
          var graphic = new Graphic(result.graphic.geometry, symbolConcPoly);
          mapContext.state.mapView.graphics.add(graphic);
        });

        // MULTIPOINT FOR DEBUGGING
        //var graphic = new Graphic(multipointGeometry, symbolConcPoly, {});
        //mapContext.state.mapView.graphics.add(graphic);

        await delay(5000);
        if (mapContext.state.searchToGraphic === false) {
          mapContext.state.mapView.graphics.removeAll();
        }

      } catch (error) {
        console.error('queryFeatures failed, layer:', queryLayer, 'error:', error);
      }
    }

    queryPointsInChunks();
  }, [searchObj]);

  useEffect(() => {
    document.title = "Judumo Portalas";
  }, []);


  return (
    <>
      <Header />
      <ButtonApp
        HeatMap={() => {
          setMapValue(0);
        }}
        DetailedMap={() => {
          // POP-up template turi rodyti antrame uzdavinyje
          // Kalendorius selectavimo galmybe datoms kurioms turim duomenu
          // Ar nereikia ismti komponentu is analitikos sidebar
          setMapValue(1);
        }}
        CompareMap={() => {


          setMapValue(2);
        }}
        GridMap={() => {
          setMapValue(3);
        }}
        VTMap={() => {
          setMapValue(4);
        }}
      />
      {mapContext.state.layerLoading === 1 ||
      mapContext.state.layerLoading === 2 ? (
        <div id="layerLoaderWrapper">
          <br />
          {MapValue === 3
            ? "Kraunamas Pasiekiamumas"
            : "Kraunamas Sluoksnis"}{" "}
          <br />
          <div class="loader loaderCentered" id="layerLoader"></div>
        </div>
      ) : (
        <></>
      )}
      <InfoCard></InfoCard>
      <Error></Error>
      <div className="mapDiv" ref={mapDiv}></div>{" "}
      {/*initialRender === 1 ? 
        <Lookup/> :
        ""*/}
      {
      }
      {MapValue === 0 ? (
        <>
          <DataInfo mapValue={0}></DataInfo>
          <DateWidgetHeatMap/>
          <DataWidget
            handleStrava={"Strava"}
            handleSISP={"SISP"}
            handleOperator={"Operator"}
          />

          {
          }
          <IconWidget
            handleBike={"Bike"}
            handleCar={"Car"}
            handleBus={"Bus"}
            handleHuman={"Pedestrian"}
            handleAll={"Sum"}
            availData={["Bike", "Human", "Car", "Bus"]}
            heatmapOp={true}
            heatmapAll={true}
          />
          <div class={"HideSidebarHeatmap"} id={"HideSidebarHeatmapId"}>
            <HideSidebar text={"Heatmap"}></HideSidebar>
          </div>

          <div id={"SidebarGridHeatmap"} className={"MenuColor"}>
            <ContextLayers></ContextLayers>
          </div>
          <div
            id={"popUpCall"}
            onClick={() => {
              mapContext.dispatch({
                callPopup: true,
              });
            }}
          >
            i
          </div>
          {mapContext.state.timePicker ? (
            <TimePicker hour={"07:00"}></TimePicker>
          ) : (
            <></>
          )}
          {mapContext.state.data.toLowerCase() === "sisp" ? (
            <LegendSISP Year={SISPDate[0]} Month={SISPDate[1]}></LegendSISP>
          ) : (
            <Legend></Legend>
          )}
        </>
      ) : MapValue === 1 ? (
        <>
          <IconWidget
            handleBike={"Bike"}
            handleCar={"Car"}
            handleBus={"Bus"}
            handleHuman={"Pedestrian"}
            handleAll={"Sum"}
            availData={["Bike", "Human", "Car", "Bus"]}
            heatmapOp={true}
          />
          <SearchToGraphic />
          <ClearButton />
          <HideSidebar text={"Analitiką"}></HideSidebar>
          <Sidebar data={layerData} token={token} />
        </>
      ) : MapValue === 2 ? (
        <>
          {mapContext.state.multiSelect ? (
            <IconWidgetMulti
              handleBike={"Car"}
              handleCar={"Car"}
              handleBus={null}
              handleHuman={null}
              availData={["Car", "Bike", "Human", "Bus"]}
            />
          ) : (
            <IconWidget
              handleBike={"Bike"}
              handleCar={"Car"}
              handleBus={"Bus"}
              handleHuman={"Pedestrian"}
              availData={["Bike", "Human", "Car", "Bus"]}
            />
          )}

          <ClearButton />
          <HideSidebar text={"Palyginimą"}></HideSidebar>
          <CompareSidebar data={response} token={token} />
        </>
      ) : MapValue === 3 ? (
        <>
          <Grid MapValue={MapValue} />
          <ClearButton customString={"Nėra parinktų gardelių"} />
        </>
      ) : MapValue === 4 ? (
        <>
          <VTMap/>
        </>
      ):(
        <></>
      )}
    </>
  );
}

export default Appv2;
